/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import moment from "moment";
import * as types from "./types";

export const state = {
  resources: [],
  loadingData: false,
  totalResources: 0,
  currentPage: 1,
  filtersInitialDate: moment()
    .startOf("month")
    .format("YYYY-MM-DD"),
  filtersFinalDate: moment()
    .endOf("month")
    .format("YYYY-MM-DD"),
  filtersDepositInitialDate: moment()
    .startOf("year")
    .format("YYYY-MM-DD"),
  filtersDepositFinalDate: moment()
    .add(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD"),
  status: "",
  limitOptions: [10, 25, 50, 100],
  limit: 100,
  page: 1,
  ordination: "",
  filtersCardBrand: "",
  filtersOrdination: "",
  filtersStatus: "",
  filtersPartner: "",
  subtotal: 0,
  showFilters: false,
  filterParams: {
    page: 1,
    limit: 10,
    filterrific: {
      with_due_on_between: {
        start_at: null,
        end_at: null,
      },
      status: null,
      with_credit_card_brand: null,
      with_partner: null,
      sorted_by: null
    }
  },
  errors: null,
  showError: false,
  depositData: null
}

export const mutations = {
  [types.FILTER_STATUS](state, status) {
    state.filterStatus = status;
  },
  [types.FILTER_VISIBLE](state, status) {
    state.filterVisible = status;
  },
  [types.SUBTOTAL](state, subtotal) {
    state.subtotal = subtotal;
  },
  [types.SET_DEPOSITS_LIST](state, list) {
    state.list = list;
  },
  [types.RESOURCES](state, resources) {
    state.resources = resources;
  },
  [types.CURRENT_PAGE](state, param) {
    state.currentPage = param;
    state.page = param;
  },
  [types.PAGE](state, param) {
    state.currentPage = param;
    state.page = param;
  },
  [types.LIMIT](state, limit) {
    state.limit = limit;
  },
  [types.LOADING_DATA](state, param) {
    state.loadingData = param;
  },
  [types.SET_CURRENT_PAGE](state, param) {
    state.currentPage = param;
    state.page = param;
  },
  [types.SET_TOTAL_RESOURCES](state, param) {
    state.totalResources = param;
  },
  [types.TOTAL_RESOURCES](state, param) {
    state.totalResources = param;
  },
  [types.SET_FILTER_INITIAL_DATE](state, date) {
    state.filtersInitialDate = date;
  },
  [types.SET_FILTER_FINAL_DATE](state, date) {
    state.filtersFinalDate = date;
  },
  [types.FILTER_INITIAL_DATE](state, date) {
    state.initialDate = date;
  },
  [types.FILTER_FINAL_DATE](state, date) {
    state.finalDate = date;
  },
  [types.SET_FILTER_DEPOSIT_INITIAL_DATE](state, date) {
    state.filtersDepositInitialDate = date;
  },
  [types.SET_FILTER_DEPOSIT_FINAL_DATE](state, date) {
    state.filtersDepositFinalDate = date;
  },
  [types.SET_FILTER_CARD_BRAND](state, cardBrand) {
    state.filtersCardBrand = cardBrand;
  },
  [types.FILTER_STATUS](state, status) {
    state.status = status;
  },
  [types.SET_FILTER_STATUS](state, status) {
    state.filtersStatus = status;
  },
  [types.ORDINATION](state, newOrdintation) {
    state.ordination = newOrdintation;
  },
  [types.SET_FILTER_ORDINATION](state, ordination) {
    state.filtersOrdination = ordination;
  },
  [types.SHOW_FILTERS](state, param) {
    state.showFilters = param;
  },
  [types.FILTER_PARAMS](state, param) {
    state.filterParams = param;
  },
  [types.SET_FILTER_PARTNER](state, partner) {
    state.filtersPartner = partner;
  },
  [types.ERRORS](state, errors) {
    state.errors = errors;
  },
  [types.SHOW_ERROR](state, showError) {
    state.showError = showError;
  },
  [types.SET_DEPOSIT_DATA](state, deposit) {
    state.depositData = deposit;
  }
};
